import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { User, UserOrganization } from 'src/app/core/auth/models';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { OrganizationService } from 'src/app/core/auth/services/organization.service';
import { Menu } from '../../models/menu';
import { DictionaryService } from 'src/app/modules/dictionary/services/dictionary.service';
import { environment } from 'src/environments/environment';
import { DynamicEntityDataRequest } from 'src/app/modules/dictionary/models/dynamic-entity-data-request';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
})
export class SidemenuComponent  implements OnInit {

  user = inject(AuthService).$user;

  public appPages: Menu[] = [];

  organization!: UserOrganization | null;
  currentUser!: User | null;

  constructor(
    private router: Router, 
    private authService: AuthService, 
    private menuCotroller: MenuController, 
    private menusService: MenuService,
    private dictionaryService: DictionaryService,
    private organizationService: OrganizationService) { 

    }

  ngOnInit() {

    this.authService.$user.subscribe(user => {
      this.currentUser = user;
        this.menuCotroller.enable(user ? true : false);

        this.organizationService.selectedOrganization$.subscribe(organization =>  {
          this.organization = organization;
          this.getMenu();
        })
        
    });

    this.menusService.menuChanged$.subscribe(() => {
      this.getMenu();
    });
  
  }




  logout() {
    this.authService.logOut(this.authService.getToken())
    .subscribe({
      next: resp => {
        this.authService.removeToken();
        this.authService.$user.next(null);
        this.router.navigate(['auth/login']);
      }
    });
  }

  getMenu() {
    this.appPages = [
      { title: 'Inicio', url: `/${this.organization?.name}`, icon: 'home-outline', iconUrl: ''  },
      { title: 'Conectores', url: ``, icon: '', iconUrl: '/assets/icons/Connected.svg',
        children: [
          { title: 'Lista de conectores', url: `/${this.organization?.name}/connectors`, icon: '', iconUrl: ''  },
          { title: 'Configuración de conectores', url: `/${this.organization?.name}/connectors/config`, icon: '', iconUrl: ''  },
        ]
      },
      { title: 'Flujo de conectores / Funciones', url: `/${this.organization?.name}/flows`, icon: '', iconUrl: './assets/icons/account_tree.svg'  },
      { title: 'Consultas', url: `queries/list`, icon: 'pie-chart-outline', iconUrl: '', children: [
        { title: "Nuevo tablero", url: `/queries/create-dashboard`, icon: '', iconUrl: ''  },
        { title: 'Lista de consultas', url: `/queries/list`, icon: '', iconUrl: ''  },
      ]
       },
      { title: 'Diccionario de datos', url: `/dictionary/entity`, icon: 'server-outline', iconUrl: '' },
      { title: 'Formularios', url: ``, icon: 'document-text-outline', iconUrl: '', children: [
        { title: 'Lista de formularios', url: `/forms/list`, icon: '', iconUrl: ''  },
        { title: 'Nuevo formulario', url: `/forms/new-form`, icon: '', iconUrl: ''  }

     ] },
      { title: 'Organizaciones', url: `auth/organizations`, icon: 'business-outline', iconUrl: '' },
      { title: 'Usuarios', url: `/users`, icon: 'people-outline', iconUrl: '' }
    ];


        const dataRequest: DynamicEntityDataRequest = {
          pageNumber: 1,
          pageSize: 10,
          filters: [
            {
              field: 'organizationId',
              value: String(this.organization?.id),
            }
          ]
        }
        
    this.dictionaryService.getDyamicEntityRecords(dataRequest, environment.dashboardsEntityId)
    .subscribe({
      next: (resp) => {
         const dashboards = resp.records.map((dashboard) => {
          return { title: dashboard.code, url: `/queries/dashboard/${dashboard.idTelar}`, icon: '', iconUrl: '' };
        });

        const optionsMenu = this.appPages[3].children?.filter((option) => option.title === 'Lista de consultas' || option.title === 'Nuevo tablero');
     
        this.appPages[3].children = [...optionsMenu!, ...dashboards];
      }
    });
  }

}
